"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(require("lodash/get"));
var dragOffset_1 = __importDefault(require("./dragOffset"));
var dragOperation_1 = __importDefault(require("./dragOperation"));
var refCount_1 = __importDefault(require("./refCount"));
var dirtyHandlerIds_1 = __importDefault(require("./dirtyHandlerIds"));
var stateId_1 = __importDefault(require("./stateId"));
function reduce(state, action) {
    if (state === void 0) { state = {}; }
    return {
        dirtyHandlerIds: dirtyHandlerIds_1.default(state.dirtyHandlerIds, {
            type: action.type,
            payload: __assign({}, action.payload, { prevTargetIds: get_1.default(state, 'dragOperation.targetIds', []) }),
        }),
        dragOffset: dragOffset_1.default(state.dragOffset, action),
        refCount: refCount_1.default(state.refCount, action),
        dragOperation: dragOperation_1.default(state.dragOperation, action),
        stateId: stateId_1.default(state.stateId),
    };
}
exports.default = reduce;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/reducers/index.js
// module id = 736
// module chunks = 0